// Module
var code = "<div class=\"contextual-menu hidden-print\"> <wt-contextual-control fields=\"vm.properties\" form-controller=\"vm.formController\" item=\"vm.configuration\" has-property-types=\"true\" modern-design=\"true\" on-cancel=\"vm.onCancel()\" save=\"vm.onSave()\"> </wt-contextual-control> </div>";
// Exports
module.exports = code;